import { UserPlus, LogIn, ArrowRight, ArrowLeft } from 'lucide-react'

import { Card } from '@/components/ui/card'

interface AuthLandingScreenProps {
  onSignIn: () => void
  onSignUp: () => void
  onBack: () => void
}

const AuthLandingScreen = ({
  onSignIn,
  onSignUp,
  onBack,
}: AuthLandingScreenProps) => {
  return (
    <div className="h-[600px] flex flex-col bg-white dark:bg-gray-900">
      {/* Back button - positioned at top left of screen */}
      <div className="absolute top-4 left-4 z-10">
        <button
          onClick={onBack}
          className="p-4 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-300" />
        </button>
      </div>

      <div className="p-6 space-y-6 flex-1 flex flex-col justify-center">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="flex items-center justify-center space-x-3">
            <h1 className="text-2xl font-heading font-bold text-gray-900 dark:text-white tracking-tight mr-[-10px]">
              Welcome to
            </h1>
            <img
              src="/paytrie-logo.png"
              alt="Paytrie"
              className="h-12 w-auto hidden dark:block"
            />
            <img
              src="/paytrie-logo-dark.png"
              alt="Paytrie"
              className="h-12 w-auto dark:hidden"
            />
          </div>
          <p className="text-gray-600 dark:text-gray-400 font-primary">
            Send money globally with ease
          </p>
        </div>

        {/* Authentication Options */}
        <div className="space-y-4">
          {/* Sign In */}
          <Card
            className="p-3 cursor-pointer hover:shadow-md transition-shadow border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-500 bg-white dark:bg-gray-800"
            onClick={onSignIn}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                  <LogIn className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white">
                    Sign In
                  </h3>
                </div>
              </div>
              <ArrowRight className="w-5 h-5 text-gray-400 dark:text-gray-500" />
            </div>
          </Card>

          {/* Sign Up */}
          <Card
            className="p-3 cursor-pointer hover:shadow-md transition-shadow border-gray-200 dark:border-gray-700 hover:border-green-300 dark:hover:border-green-500 bg-white dark:bg-gray-800"
            onClick={onSignUp}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
                  <UserPlus className="w-6 h-6 text-green-600 dark:text-green-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white">
                    Sign Up
                  </h3>
                </div>
              </div>
              <ArrowRight className="w-5 h-5 text-gray-400 dark:text-gray-500" />
            </div>
          </Card>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-4 py-3">
        <div className="text-center">
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">
            Secured by Paytrie • Circle Payments Network
          </p>
        </div>
      </div>
    </div>
  )
}

export default AuthLandingScreen
